const search = (state) => state.search;
const searchResults = (state) => state.modal.searchResults;
const searchLoading = (state) => state.searchLoading;
const numDocs = (state) => state.numDocs;
const numHits = (state) => state.numHits;
const showAnalytics = (state) => state.showAnalytics;
const savedSearch = (state) => state.savedSearch;
const modal = (state) => state.modal;

export const getters = {
  search,
  searchResults,
  searchLoading,
  numHits,
  numDocs,
  showAnalytics,
  savedSearch,
  modal,
};
